<template>
  <div>
    <div class="pb-2">
      <h1 class="title title--h1 first-title title__separate">Portfolio</h1>
    </div>
    <div>
      <div class="select" :class="{ 'is-open': selectOpen }">
        <span class="placeholder" @click="selectOpen = !selectOpen">Select category</span>
        <ul class="filter">
          <li class="filter__item">Category</li>
          <li
            v-for="cat in categories"
            :key="cat.value"
            :data-filter="cat.value"
            class="filter__item"
            :class="{ active: activeFilter === cat.value }"
          >
            <a href="#filter" class="filter__link" :class="{ active: activeFilter === cat.value }" @click.prevent="selectCategory(cat.value)">
              {{ cat.label }}
            </a>
          </li>
        </ul>
      </div>

      <div class="row">
        <div
          v-for="item in filteredItems"
          :key="item.title"
          class="col-12 col-md-6"
        >
          <figure class="gallery-grid__item" :class="'category-' + item.category">
            <div class="box-gallery-grid__item box__border">
              <div class="gallery-grid__image-wrap">
                <div class="portfolio-item__category">
                  <span>{{ item.category }}</span>
                </div>
                <img :src="item.image" :alt="item.alt" class="gallery-grid__image cover zoomable" @click="openLightbox(item.image, item.alt)">
                <div v-if="item.caption" class="caption">
                  <div class="blur"></div>
                  <div class="caption-text">
                    <h1 v-if="item.captionTitle">{{ item.captionTitle }}</h1>
                    <p>{{ item.caption }}</p>
                  </div>
                </div>
              </div>
              <figcaption class="gallery-grid__caption">
                <h4 class="title title--h4 gallery-grid__title">{{ item.title }}</h4>
                <a
                  v-for="link in item.links"
                  :key="link.label"
                  :href="link.href || '#'"
                  :target="link.href ? '_blank' : ''"
                  :rel="link.href ? 'noopener' : ''"
                  class="link-btn mt-2"
                >
                  {{ link.label }}
                </a>
              </figcaption>
            </div>
          </figure>
        </div>
      </div>
    </div>
    <!-- Lightbox overlay -->
    <div v-if="lightboxOpen" class="lightbox-overlay" @click="closeLightbox">
      <span class="lightbox-close">&times;</span>
      <img :src="lightboxImage" :alt="lightboxAlt" class="lightbox-image" @click.stop>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortfolioView',
  data() {
    return {
      activeFilter: '*',
      selectOpen: false,
      lightboxOpen: false,
      lightboxImage: '',
      lightboxAlt: '',
      categories: [
        { value: '*', label: 'All' },
        { value: 'Certifications', label: 'Certifications' },
        { value: 'Project', label: 'Project' },
        { value: 'Award', label: 'Awards' }
      ],
      items: [
        {
          title: 'CKA - Certified Kubernetes Administrator',
          category: 'Certifications',
          image: require('@/assets/images/CKA_page-0001.jpg'),
          alt: 'CKA_Certified_Kubernetes_Administrator',
          caption: 'Certified by Cloud Native Computing Foundation (CNCF) for Kubernetes cluster administration',
          captionTitle: null,
          links: [{ label: 'Verify', href: 'https://www.credly.com/earner/earned/badge/11ba2a10-f708-4dab-a763-016fe052ccc1' }]
        },
        {
          title: 'CKAD - Certified Kubernetes Application Developer',
          category: 'Certifications',
          image: require('@/assets/images/ckad_page-0001.jpg'),
          alt: 'CKAD_Certified_Kubernetes_Application_Developer',
          caption: 'Certified by Cloud Native Computing Foundation (CNCF) for Kubernetes application development',
          captionTitle: null,
          links: [{ label: 'Verify', href: 'https://www.credly.com/earner/earned/badge/7fb86e98-3a59-4f65-b911-d25f558a3e98' }]
        },
        {
          title: 'AWS Certified Cloud Practitioner',
          category: 'Certifications',
          image: require('@/assets/images/AWS_Certified_Cloud_Practitioner_8e3fa901d8.png'),
          alt: 'AWS_Certified_Cloud_Practitioner',
          caption: 'Certified by Amazon Web Services for cloud fundamentals and AWS services',
          captionTitle: null,
          links: [{ label: 'Verify' }]
        },
        {
          title: 'CP-DOF - DevOps Foundation',
          category: 'Certifications',
          image: require('@/assets/images/cpdof.jpg'),
          alt: 'CP_DOF_DevOps_Foundation',
          caption: 'Certified Professional DevOps Foundation by DevOps Institute',
          captionTitle: null,
          links: [{ label: 'Certificate' }]
        },
        {
          title: 'DevSecOps Fundamentals',
          category: 'Certifications',
          image: require('@/assets/images/devsecops.jpeg'),
          alt: 'DevSecOps_Fundamentals',
          caption: 'DevSecOps Fundamentals certification from Udemy',
          captionTitle: null,
          links: [{ label: 'Certificate' }]
        },
        {
          title: 'AWS Cloud Practitioner Essentials',
          category: 'Certifications',
          image: require('@/assets/images/AwsCloudpractionalessensial.jpeg'),
          alt: 'AWS_Cloud_Practitioner_Essentials',
          caption: 'AWS Cloud Practitioner Essentials (Second Edition) - Completed July 2019',
          captionTitle: null,
          links: [{ label: 'Certificate' }]
        },
        {
          title: 'CI/CD Transformation',
          category: 'Project',
          image: require('@/assets/images/cicd_transform.png'),
          alt: 'CICD_Transformation',
          caption: 'Jenkins - AWS CodePipeline - ArgoCD',
          captionTitle: 'Tech Stack',
          links: [{ label: '75% Faster Releases' }, { label: '40% Fewer Errors' }]
        },
        {
          title: 'DevSecOps Integration',
          category: 'Project',
          image: require('@/assets/images/devsecops_integration.svg'),
          alt: 'DevSecOps_Integration',
          caption: 'SonarQube - Twistlock - SAST/DAST',
          captionTitle: 'Tech Stack',
          links: [{ label: '35% Fewer Vulnerabilities' }]
        },
        {
          title: 'Get Password Utility',
          category: 'Project',
          image: require('@/assets/images/get_password_utility.svg'),
          alt: 'Get_Password_Utility',
          caption: 'AES-256 Encryption - Central DB - Auto Rotation - Audit Logs',
          captionTitle: 'Tech Stack',
          links: [{ label: 'Eliminated Password Fatigue' }, { label: 'Automated Rotation' }, { label: 'AES-256 Encrypted Vault' }]
        },
        {
          title: 'VCD vApp Lease Automation',
          category: 'Project',
          image: require('@/assets/images/vcd_vapp_lease_automation.svg'),
          alt: 'VCD_vApp_Lease_Automation',
          caption: 'Bash - Python - VMware Cloud Director API - Kubernetes - Cron',
          captionTitle: 'Tech Stack',
          links: [{ label: '50% Reduced Unused vApps' }, { label: 'Zero Manual Intervention' }, { label: 'Daily Automated Lease Renewal' }]
        },
        {
          title: 'Mbounce Tool (Innovation)',
          category: 'Project',
          image: require('@/assets/images/mbounce_tool.svg'),
          alt: 'Mbounce_Tool_Innovation',
          caption: 'Java JSP - Shell Scripting - WebLogic - Database',
          captionTitle: 'Tech Stack',
          links: [{ label: 'Internal Innovation' }, { label: 'Unified Console' }, { label: '7 Key Features' }]
        },
        {
          title: 'Transform Collaborate Partner Award',
          category: 'Award',
          image: require('@/assets/images/Transform Collaborate Partner Award.jpeg'),
          alt: 'Transform_Collaborate_Partner_Award',
          caption: 'Led Kubernetes GitOps project that secured new client, generating $1M revenue (2024)',
          captionTitle: null,
          links: [{ label: 'Amdocs 2024' }]
        }
      ]
    }
  },
  computed: {
    filteredItems() {
      if (this.activeFilter === '*') return this.items
      return this.items.filter(item => item.category === this.activeFilter)
    }
  },
  methods: {
    selectCategory(value) {
      this.activeFilter = value
      this.selectOpen = false
    },
    handleClickOutside(e) {
      const selectEl = this.$el.querySelector('.select')
      if (selectEl && !selectEl.contains(e.target)) {
        this.selectOpen = false
      }
    },
    openLightbox(image, alt) {
      this.lightboxImage = image
      this.lightboxAlt = alt
      this.lightboxOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeLightbox() {
      this.lightboxOpen = false
      document.body.style.overflow = ''
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.lightboxOpen) {
        this.closeLightbox()
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.row > .col-md-6 > .gallery-grid__item {
  width: 100% !important;
  margin-bottom: 1rem;
}

.gallery-grid__image.zoomable {
  cursor: zoom-in;
  transition: opacity 0.2s;
}
.gallery-grid__image.zoomable:hover {
  opacity: 0.85;
}

.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  cursor: zoom-out;
  animation: fadeIn 0.2s ease;
}
.lightbox-image {
  max-width: 90%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  cursor: default;
  animation: zoomIn 0.25s ease;
}
.lightbox-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: #fff;
  cursor: pointer;
  line-height: 1;
  z-index: 100000;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.lightbox-close:hover {
  opacity: 1;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes zoomIn {
  from { transform: scale(0.85); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>
